<template>
  <div class="main-body">
    <div class="header">审核评估</div>
    <div class="out">

      <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                :height="th" border>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">

            <el-table size="mini" :data="props.row.listElderlyBedGoodsRelDTO" border>
              <el-table-column prop="bedGoodsName" label="改造项目"></el-table-column>
            </el-table>

          </template>
        </el-table-column>



        <el-table-column label="老人姓名" prop="elderlyName" width="100"></el-table-column>

        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">待评估</span>
            <span v-if="scope.row.status==1">待审核</span>
            <span v-if="scope.row.status==2">审核通过</span>
            <span v-if="scope.row.status==3">审核驳回</span>
            <span v-if="scope.row.status==4">再评估待审核</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="timefilter" label="时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini"
                       @click="pass(scope.$index, scope.row)">通过</el-button>
            <el-button type="text" size="mini"
                       @click="reject(scope.$index, scope.row)">驳回</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd"
         v-on:closeAdd="closeAdd"
         v-on:getList="getList"></Add>


  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./Add";


export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalAdd:false,
      voucherDialog:false,

      showModalGetElderly:false,

      elderlyCode:'',
      elderlyName:'',


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


    }
  },
  components:{
    Add,
  },

  created(){

    this.getList();

    this.th = this.$store.state.tableHeight+50;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"AssessElderlyRel/InsPageWaitCheck",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });

    },

    pass(index,row){

      this.$confirm('确定通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl+"AssessElderlyRel/AssessCheck",
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
            assessElderlyRelCode:row.assessElderlyRelCode,
            status:2,
            auditMessage:'通过',
          }
        }).then( (response)=> {
          this.loading = false;
          if(response.data.error == 0){
            this.getList();
          }else if(response.data.error == 1){
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
        //this.$message({type: 'info', message: '已取消删除'});
      });

    },

    reject(index,row){

      this.$confirm('确定不通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl+"AssessElderlyRel/AssessCheck",
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
            assessElderlyRelCode:row.assessElderlyRelCode,
            status:3,
            auditMessage:'不通过',
          }
        }).then( (response)=> {
          this.loading = false;
          if(response.data.error == 0){
            this.getList();
          }
          else if(response.data.error == 1){
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
        //this.$message({type: 'info', message: '已取消删除'});
      });

    },



  }
}
</script>
<style lang="scss" scoped>

</style>
